import { render } from "./IconBin.vue?vue&type=template&id=1556f382&scoped=true"
import script from "./IconBin.vue?vue&type=script&lang=js"
export * from "./IconBin.vue?vue&type=script&lang=js"

import "./IconBin.vue?vue&type=style&index=0&id=1556f382&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.29_vue@3.2.13_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1556f382"]])

export default __exports__